import React from "react";
import "../App.scss";
import { Nav } from "react-bootstrap";
import AclApi from "../api/AclApi";
import {
  RiDashboardLine,
  RiUser3Line,
  RiShoppingBag3Line,
  RiTruckLine,
  RiSettings4Line,
  RiFolderLine,
  RiStore2Line
} from "react-icons/ri";

interface MenuItem {
  id: number;
  label: string;
  relativePath: string;
  accessRoles: string;
  sortOrder: number;
  groupName?: string;
}

interface State {
  menus: MenuItem[];
  currentPath: string;
}

class LeftMenu extends React.Component<{}, State> {
  constructor(props: {}) {
    super(props);
    this.state = {
      menus: [],
      currentPath: window.location.pathname,
    };
  }

  componentDidMount() {
    this.loadMenus();
  }

  async loadMenus() {
    const response = await AclApi.listMenus();
    if (response.success) {
      const sorted = (response.data as MenuItem[]).sort((a, b) => a.sortOrder - b.sortOrder);
      this.setState({ menus: sorted });
    }
  }

  getIcon = (label: string, group: string) => {
    const text = (label + group).toLowerCase();
    if (text.includes("ana sayfa") || text.includes("dashboard")) return <RiDashboardLine />;
    if (text.includes("kullanıcı") || text.includes("müşteri")) return <RiUser3Line />;
    if (text.includes("ürün") || text.includes("stok") || text.includes("depo")) return <RiShoppingBag3Line />;
    if (text.includes("lojistik") || text.includes("sevk")) return <RiTruckLine />;
    if (text.includes("mağaza") || text.includes("bayi")) return <RiStore2Line />;
    if (text.includes("ayar")) return <RiSettings4Line />;
    return <RiFolderLine />;
  };

  render() {
    const groupedMenus = this.state.menus.reduce<Record<string, MenuItem[]>>(
      (acc, menu) => {
        const group = menu.groupName || "Diğer";
        if (!acc[group]) acc[group] = [];
        acc[group].push(menu);
        return acc;
      },
      {}
    );

    return (
      <div className="left-menu-container">
        {/* Logo alanı kaldırıldı, direkt menüler başlıyor */}

        <Nav className="flex-column w-100">
          {Object.entries(groupedMenus).map(([groupName, menus]) => (
            <div key={groupName} className="menu-group-wrapper">

              {/* Grup Başlığı: Solunda kırmızı çizgi var */}
              <div className="menu-group-header">
                {groupName}
              </div>

              {menus.map((menu) => {
                const isActive = this.state.currentPath === menu.relativePath;

                return (
                  <Nav.Link
                    key={menu.id}
                    href={menu.relativePath}
                    className={`menu-item-link ${isActive ? "active" : ""}`}
                  >
                    <span className="menu-icon">
                      {this.getIcon(menu.label, groupName)}
                    </span>
                    {menu.label}
                  </Nav.Link>
                );
              })}
            </div>
          ))}
        </Nav>
      </div>
    );
  }
}

export default LeftMenu;